import React from 'react';
import ReceiptLink from './ReceiptLink';

export default function OptionsMenu({ protocol, status }) {
    return (
        <div className="dropdown">
            <a className="btn btn-sm btn-icon-only text-light"
                href="#"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <i className="fas fa-ellipsis-v" />
            </a>
            <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                <ReceiptLink protocol={protocol} status={status} />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/OptionsMenu.js